module.exports = __webpack_public_path__ + "static/media/chuyinshan_web.3eafd751.png";